export default function XSLT_Client() {
  return (
    <div>
      <h1>XSLT_Client</h1>
      <p>This is the XSLT_Client component.</p>
    </div>
  );
}